{
  "title": "Mind Spike",
  "source": "Xanathar's Guide to Everything",
  "levelAndSchool": "2nd-level divination",
  "level": 2,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You reach into the mind of one creature you can see within range. The target must make a Wisdom saving throw, taking 3d8 psychic damage on a failed save, or half as much damage on a successful one. On a failed save, you also always know the target's location until the spell ends, but only while the two of you are on the same plane of existence. While you have this knowledge, the target can’t become hidden from you, and if it’s invisible, it gains no benefit from that condition against you.",
    "At Higher Levels. When you cast this spell using a spell slot of 3rd level or higher, the damage increases by 1d8 for each slot level above 2nd."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
